import type { CreateDocumentItemDTO } from "./types";

export function round2(n: number): number {
  return Math.round(n * 100) / 100;
}

export type LineItemComputed = {
  orderIndex: number;
  description: string;
  detail: string | null;
  quantity: number;
  unit: string | null;
  unitPrice: number;
  discountAmount: number;
  taxRate: number;
  lineTotal: number;
};

/**
 * ຄຳນວນຍອດເອກະສານຈາກລາຍບັນທຶດ — ກົງກັບ create-document
 */
export function computeTotalsFromLineItems(
  items: CreateDocumentItemDTO[],
  docDiscount: number,
  docTaxRate: number,
): {
  itemsWithTotal: LineItemComputed[];
  subtotal: number;
  taxAmount: number;
  total: number;
} {
  const itemsWithTotal: LineItemComputed[] = items.map((item, i) => {
    const lineSub = item.quantity * item.unitPrice - (item.discountAmount ?? 0);
    const lineTotal = round2(lineSub);
    return {
      orderIndex: i,
      description: item.description.trim() || "—",
      detail: item.detail?.trim() ? item.detail.trim() : null,
      quantity: item.quantity,
      unit: item.unit?.trim() || null,
      unitPrice: item.unitPrice,
      discountAmount: item.discountAmount ?? 0,
      taxRate: item.taxRate ?? 0,
      lineTotal,
    };
  });

  const subtotal = round2(
    itemsWithTotal.reduce((sum, row) => sum + row.lineTotal, 0),
  );
  const taxAmount = round2((subtotal - docDiscount) * docTaxRate);
  const total = round2(subtotal - docDiscount + taxAmount);

  return { itemsWithTotal, subtotal, taxAmount, total };
}

export function inferTaxRateFromDocumentTotals(q: {
  subtotal: number;
  discountAmount: number;
  taxAmount: number;
}): number {
  const base = q.subtotal - q.discountAmount;
  if (base <= 0) return 0;
  const r = q.taxAmount / base;
  return Number.isFinite(r) ? r : 0;
}
